import { useMemo, useState } from 'react';

import highchartsMore from 'highcharts/highcharts-more';
import Highcharts from 'highcharts/highstock';
import apo from 'highcharts/indicators/apo';
import aroon from 'highcharts/indicators/aroon';
import arronOsc from 'highcharts/indicators/aroon-oscillator';
import bolinger from 'highcharts/indicators/bollinger-bands';
import cmo from 'highcharts/indicators/cmo';
import dema from 'highcharts/indicators/dema';
import di from 'highcharts/indicators/disparity-index';
import dpo from 'highcharts/indicators/dpo';
import ema from 'highcharts/indicators/ema';
import indicators from 'highcharts/indicators/indicators';
import macd from 'highcharts/indicators/macd';
import ppo from 'highcharts/indicators/ppo';
import psar from 'highcharts/indicators/psar';
import regressions from 'highcharts/indicators/regressions';
import roc from 'highcharts/indicators/roc';
import rsi from 'highcharts/indicators/rsi';
import tema from 'highcharts/indicators/tema';
import trendline from 'highcharts/indicators/trendline';
import trix from 'highcharts/indicators/trix';
import annotationsAdvanced from 'highcharts/modules/annotations-advanced.js';
import exporting from 'highcharts/modules/exporting';
import fullScreen from 'highcharts/modules/full-screen';
import priceIndicator from 'highcharts/modules/price-indicator';
import sankey from 'highcharts/modules/sankey.js';
import stockTools from 'highcharts/modules/stock-tools.js';

import type { ChartsBlockTabType, TemplateChartSeries } from '../types';

highchartsMore(Highcharts);
indicators(Highcharts);
annotationsAdvanced(Highcharts);
priceIndicator(Highcharts);
bolinger(Highcharts);
dema(Highcharts);
ema(Highcharts);
regressions(Highcharts);
psar(Highcharts);
tema(Highcharts);
trendline(Highcharts);
apo(Highcharts);
aroon(Highcharts);
arronOsc(Highcharts);
cmo(Highcharts);
dpo(Highcharts);
di(Highcharts);
macd(Highcharts);
ppo(Highcharts);
roc(Highcharts);
rsi(Highcharts);
sankey(Highcharts);
trix(Highcharts);
fullScreen(Highcharts);
stockTools(Highcharts);
exporting(Highcharts);

const indicatorTitles = new Map([
  ['bb', 'Bollinger Bands'],
  ['linearRegression', 'Linear Regression'],
  ['linearRegressionAngle', 'Linear Regression Angle'],
  ['linearRegressionIntercept', 'Linear Regression Intercept'],
  ['linearRegressionSlope', 'Linear Regression Slope'],
  ['apo', 'Absolute Price'],
  ['atr', 'Average True Range'],
  ['natr', 'NATR']
]);

(function (H: any) {
  const seriesTypes: any = H.seriesTypes;
  for (const [key, value] of Object.entries(seriesTypes)) {
    const title = indicatorTitles.get(key);
    const type: any = value;
    if (title) {
      type.prototype.nameBase = title;
    }
  }
})(Highcharts);

const useMarketsChart = <T>(tab: ChartsBlockTabType<T>) => {
  const [activeTab, setActiveTab] = useState(0);

  const metadata = tab.metadata;

  const templateChartSeries: TemplateChartSeries[] = useMemo(() => {
    return tab.series;
  }, [activeTab, tab]);

  return {
    activeTab,
    setActiveTab,
    fullScreen,
    templateChartSeries,
    metadata
  };
};

export default useMarketsChart;
